
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { RegionState } from '../store/region.reducer';

// Feature Selector
export const selectRegionState = createFeatureSelector<RegionState>('region');
export const selectTabState = createFeatureSelector<RegionState>('tab');

// Individual Selectors
export const selectRegionValue = createSelector(
  selectRegionState,
  (state: RegionState) => state.Country,
);


export const selectTabValue = createSelector(
  selectRegionState,
  (state: RegionState) => state.tab,
);

